import React, { Component } from 'react';
import { connect } from "react-redux";

import { Row, Col, Container } from 'reactstrap';
import Content from '../../components/Content/Content';

import moment from "moment";
import * as actions from '../../actions/ApiActions';
import Headline from "../../components/Headline/Headline";
import AppointmentTable from "../../components/AppointmentTable/AppointmentTable";
import CreateAppointment from "../../components/CreateAppointment/CreateAppointment";
import { Redirect } from "react-router-dom";
import AdminFilters from "../../components/AdminFilters/AdminFilters";
import Spinner from "../../components/Spinner/Spinner";
import ModalOverlay from "../../components/ModalOverlay/ModalOverlay";
import Modal from "../../components/Modal/Modal";
import ApiResponse from "../../components/ApiResponse/ApiResponse";

class AdminContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appointmentDetailOpen: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      date: 0
    };

    this.createAppointment = this.createAppointment.bind(this);
    this.openAppointmentModal = this.openAppointmentModal.bind(this);
    this.closeAppointmentModal = this.closeAppointmentModal.bind(this);
    this.filter = this.filter.bind(this);
  }

  componentDidMount() {
    const { loadUserData, loadDoctorAppointments } = this.props;

    loadUserData();
    loadDoctorAppointments();
  }

  openAppointmentModal(firstname, lastname, email, phone, date) {
    this.setState({
      appointmentDetailOpen: true,
      firstname: firstname,
      lastname: lastname,
      email: email,
      phone: phone,
      date: date
    })
  }

  closeAppointmentModal() {
    this.setState({
      appointmentDetailOpen: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      date: ""
    })
  }

  createAppointment(time, repeatVal) {
    const { createAppointment, loadDoctorAppointments } = this.props;

    let value = (repeatVal > 0) ? repeatVal : 0;

    createAppointment({
      date: time * 1000,
      repeat: value,
    })
    loadDoctorAppointments();
  }

  filter(starttime) {
    const { loadDoctorAppointments } = this.props;
    loadDoctorAppointments(starttime);
  }

  render() {
    const { dashboardAppointments, dashboardAppointments_loading, auth, cancelAppointment, deleteAppointment } = this.props;

    if (!auth.authToken || !auth.currentUser) {
      return (
        <Redirect to={'/login'} />
      )
    }

    return (
      <div className={'main-wrapper'}>
        <Content>
          <Container>
            <Headline pageTitle>
              Willkommen {(auth.currentUser) ? auth.currentUser.name : ''}.
            </Headline>
            <Headline small>Dies ist Ihr persönliches Quickdoctor-Dashboard. Hier können Sie Ihre
              Termine verwalten.</Headline>
            <hr />
            <Row>
              <Col md={4}>
                <CreateAppointment
                  submitAction={this.createAppointment}
                />
              </Col>
              <Col md={8}>
                <AdminFilters filterAction={this.filter} />
                {
                  !dashboardAppointments_loading &&
                  <AppointmentTable
                    appointments={dashboardAppointments}
                    openAppointment={this.openAppointmentModal}
                    deleteAction={(id) => {
                      if (window.confirm('Möchten Sie den Termin wirklich löschen?')) deleteAppointment(
                        id)
                    }}
                    cancelAction={(id) => {
                      if (window.confirm('Möchten Sie den Termin wirklich stornieren?')) cancelAppointment(
                        id)
                    }}
                  />
                }
                {
                  dashboardAppointments_loading && <Spinner />
                }

              </Col>
            </Row>

            <ModalOverlay visible={this.state.appointmentDetailOpen} />

            <Modal visible={this.state.appointmentDetailOpen}
                   closeAction={() => this.closeAppointmentModal()}>

              <Headline>Buchungsdetails</Headline>

              <ul>
                <li><b>Termin: </b>{moment(this.state.date).format('DD.MM.YYYY HH:mm')}</li>
                <li><b>Name: </b>{this.state.firstname} {this.state.lastname}</li>
                <li><b>E-Mail: </b>{this.state.email}</li>
                <li><b>Telefon: </b>{this.state.phone}</li>
              </ul>

            </Modal>
          </Container>
        </Content>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    dashboardAppointments: state.dashboardAppointments,
    auth: state.auth,
    dashboardAppointments_loading: state.dashboardAppointments_loading
  };
}

export default connect(mapStateToProps, actions)(AdminContainer);



// WEBPACK FOOTER //
// ./src/container/doctor/AdminContainer.js